module.exports = __webpack_public_path__ + "static/media/A0538VR.cc15b74f.png";